import { Box, Button } from '@mui/material';
import { ColumnDef } from '@tanstack/react-table';
import DataTable from 'components/Common/DataTable';
import Search from 'components/Common/Search';
import { HiOutlineCog6Tooth } from 'react-icons/hi2';
import { DomainBusinessMapping } from 'apis/agency/telephony/types';

interface Props {
  rows: DomainBusinessMapping[];
  searchText: string | null;
  setSearchText: React.Dispatch<React.SetStateAction<string | null>>;
  isLoading?: boolean;
  onConfigure: (business: DomainBusinessMapping) => void;
}

export default function AsteriskMappingTable({ rows, searchText, setSearchText, isLoading, onConfigure }: Props) {
  const columns: ColumnDef<DomainBusinessMapping>[] = [
    {
      header: 'BUSINESS NAME',
      accessorKey: 'name'
    },
    {
      header: 'Account Name',
      accessorKey: 'external_reference_name'
    },
    {
      header: 'Account Id',
      accessorKey: 'external_reference_id'
    },

    {
      header: 'ACTION',
      id: 'action',

      cell: ({ row }) => (
        <Button
          variant='outlined'
          size='small'
          startIcon={<HiOutlineCog6Tooth />}
          sx={{ width: 'fit-content', borderRadius: '24px', px: 2, fontWeight: 500 }}
          onClick={() => onConfigure(row.original)}
        >
          Configure
        </Button>
      )
    }
  ];

  return (
    <>
      <Box pb={2}>
        <Search
          placeholder='Search Business'
          size='small'
          searchText={searchText}
          setSearchText={setSearchText}
          fullWidth
        />
      </Box>
      <DataTable
        data={rows}
        columns={columns}
        isLoading={isLoading}
        containerStyles={{
          borderRadius: '4px',
          '& table': {
            minWidth: 760
          }
        }}
      />
    </>
  );
}
